import { render, staticRenderFns } from "./PlanDescription.vue?vue&type=template&id=00f09ffe&"
import script from "./PlanDescription.vue?vue&type=script&lang=js&"
export * from "./PlanDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports